import { Piece, SquarePiece, CornerPiece, LinePiece, TrianglePiece, DotPiece } from "./pieces"

const PIECES: Array<Piece> = [
    new DotPiece([
        [true]
    ]),
    new LinePiece([
        [true, true]
    ]),
    new LinePiece([
        [true],
        [true],
    ]),
    new SquarePiece([
        [true, true, true],
        [true, true, true],
        [true, true, true],
    ]),
    new CornerPiece([
        [true, true, true],
        [true, null, null],
        [true, null, null],
    ]),
    new CornerPiece([
        [true, null, null],
        [true, null, null],
        [true, true, true],
    ]),
    new CornerPiece([
        [true, true, true],
        [null, null, true],
        [null, null, true],
    ]),
    new CornerPiece([
        [null, null, true],
        [null, null, true],
        [true, true, true],
    ]),
    new CornerPiece([
        [true, true],
        [true, null],
    ]),
    new CornerPiece([
        [true, true],
        [null, true],
    ]),
    new CornerPiece([
        [null, true],
        [true, true],
    ]),
    new CornerPiece([
        [true, null],
        [true, true],
    ]),
    new SquarePiece([
        [true, true],
        [true, true],
    ]),
    new LinePiece([
        [true],
        [true],
        [true],
        [true],
    ]),
    new LinePiece([
        [true, true, true, true],
    ]),
    new CornerPiece([
        [true, true, true],
        [true, null, null],
    ]),
    new CornerPiece([
        [true, null, null],
        [true, true, true],
    ]),
    new CornerPiece([
        [true, true, true],
        [null, null, true],
    ]),
    new CornerPiece([
        [null, null, true],
        [true, true, true],
    ]),
    new CornerPiece([
        [null, true],
        [null, true],
        [true, true],
    ]),
    new CornerPiece([
        [true, true],
        [null, true],
        [null, true],
    ]),
    new CornerPiece([
        [true, true],
        [true, null],
        [true, null],
    ]),
    new CornerPiece([
        [true, null],
        [true, null],
        [true, true],
    ]),
    new TrianglePiece([
        [true, null],
        [true, true],
        [true, null],
    ]),
    new TrianglePiece([
        [null, true],
        [true, true],
        [null, true],
    ]),
    new TrianglePiece([
        [null, true, null],
        [true, true, true],
    ]),
    new TrianglePiece([
        [true, true, true],
        [null, true, null],
    ]),
]

export { PIECES }
